<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi" id="dedi"><a id="page_vii"></a><em>To my wonderful mother, Anthea, who introduced me to the world of words</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?25c8b309